import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import CropUnitForm from "components/agro/cropUnits/CropUnitForm";
import { updateCropUnit } from "graphql/mutations";
import { getCropUnit } from "graphql/queries";

const CropUnitUpdateForm = ({ cropUnitId, onSuccess }) => {
  const navigate = useNavigate();
  const [cropUnit, setCropUnit] = useState();

  async function onSubmit(valuesParam) {
    try {
      const {
        farmID,
        lotID,
        name,
        plantingDate,
        cropType,
        unitType,
        quantity,
        performedById,
        photoEvidence,
        status,
        description,
        companyID,
      } = valuesParam;

      await API.graphql({
        query: updateCropUnit.replaceAll("__typename", ""),
        variables: {
          input: {
            id: cropUnitId,
              farmID,
              lotID,
              name,
              plantingDate,
              cropType,
              unitType,
              quantity:
                quantity === undefined || quantity === ""
                  ? null
                  : Number(quantity),
              performedById,
              photoEvidence,
              status,
              description,
              companyID,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/agro/crop-units");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchCropUnit(id) {
    try {
      const cropUnitData = await API.graphql(graphqlOperation(getCropUnit, { id }));
      const cropUnitItem = cropUnitData.data.getCropUnit;
      if (!cropUnitItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/agro/crop-units");
        return;
      }
      setCropUnit({
        ...cropUnitItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchCropUnit(cropUnitId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cropUnitId]);

  if (!cropUnit) return <Loader />;

  return (
    <div>
      <CropUnitForm onSubmit={onSubmit} type="update" initialValues={cropUnit} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar CropUnite",
    successUpdated: "CropUnite actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el cropUnite",
    },
  },
});

export default CropUnitUpdateForm;
